// import React, { useState, useEffect } from 'react';
// import './OneToOneReview.css';

// const CreateAdmin = () => {
//   const [userData, setUserData] = useState([]);
//   const [searchQuery, setSearchQuery] = useState('');

//   useEffect(() => {
//     // Fetch the initial data here
//     const fetchData = async () => {
//       try {
//         // const response = await fetch('http://localhost:5000/api/user', {
//           const response = await fetch(process.env.REACT_APP_SERVER_IP + '/api/admin/groups', {
//           headers: {
//             'Authorization': `Bearer ${localStorage.getItem('token')}`
//           }
//         });
//         const data = await response.json();
//         setUserData(data);
//       } catch (error) {
//         console.error('Error fetching data:', error);
//       }
//     };
//     fetchData();
//   }, []);

//   const handleSearch = async () => {
//     try {
//       const response = await fetch(`http://localhost:5000/api/user?searchQuery=${searchQuery}`);
//       const data = await response.json();
//       setUserData(data);
//     } catch (error) {
//       console.error('Error fetching data:', error);
//       // Handle error (show error message, etc.)
//     }
//   };

//   const handleChange = (e) => {
//     setSearchQuery(e.target.value);
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     handleSearch();
//   };
 
//   return (
//     <>
//       <div className="contain">
//         <main className="main-content">
//           <div className="table-container">
//             <h2>Members</h2>
//             <div className="search-container">
//               <form onSubmit={handleSubmit}>
//                 <input
//                   type="text"
//                   placeholder="Search User"
//                   value={searchQuery}
//                   onChange={handleChange}
//                 />
//                 <button type="submit">Search</button>
//               </form>
//             </div>
//             <table>
//               <thead>
//                 <tr>
//                   <th>Name</th>
//                   <th>Occupation</th>
//                   <th>E-mail</th>
//                   <th>Role</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {userData.map((entry, index) => (
//                   <tr key={index}>
//                     <td>{entry.firstName} {entry.lastName}</td>
//                     <td>{entry.occupation}</td>
//                     <td>{entry.email}</td>
//                     <td>{entry.role}</td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </main>
//       </div>
//     </>
//   );
// };

// export default CreateAdmin;




import React from 'react'

const groups = () => {
  return (
    <div>
      <h1 style={{textAlign:'center'}}>Coming Soon</h1>
    </div>
  )
}

export default groups

